import { Box, Typography } from "@mui/material";

/**
 * Registered only so `ReferenceManyField` can use `reference="sabilAudit"`.
 * History is shown on each sabil under the Change history tab.
 */
export default function SabilAuditPlaceholderList() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Change history is shown on each sabil record under the Change history tab.
      </Typography>
    </Box>
  );
}
